import { Component, Input, OnChanges, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';


import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

import { FieldTypeListParentService } from './../utils/field-type-list-parent.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { TooltipInReportComponent } from "../../tooltip-in-report/tooltip-in-report.component";
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';
import { FieldSequentialHeaderComponent } from "../../field-sequential-header/field-sequential-header.component";


@Component({
  selector: 'field-type-list-numerical',
  templateUrl: './field-type-list-numerical.component.html',
  standalone: true,
  imports: [NgClass,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    AfTranslateDirective,
    AfTranslatePipe,
    TooltipInReportComponent,
    SpanTooltipComponent, FieldSequentialHeaderComponent]
})

export class FieldTypeListNumericalComponent implements OnChanges, OnInit, OnDestroy {
  selectionAsArray:boolean = false;
  isLanding: boolean = this.customLanding.isLanding();
  fieldTypeList:any = this.fieldTypeListParent.configureFieldTypeList(this);
  custom: any = this.customLanding.getCustom();
  constructor(
    private customLanding: CustomLandingFactory,
    private fieldTypeListParent: FieldTypeListParentService) {
  }

  @Input() field:any = null;
  @Input() preSelectItem:any = '';
  @Input() listValues:any = [];
  @Input() listAll:any = [];
  @Input() public: boolean = false;;
  @Input() type:any = '';
  @Input() orderBy:any;
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();

  ngOnInit(): void {
    this.fieldTypeListParent.openWatchers(this);
  }

  ngOnChanges(): void {
   this.fieldTypeListParent.configureChanges(this);
    if(this.field){
      this.fieldTypeList.widthElementNumericalScale = (100 / this.fieldTypeList.filterList.length) +'%';
    }
  }

  selectItem(listValue: any){
    this.fieldTypeListParent.selectItem(listValue, this)
  }

  openModalRelatedInfo(fieldRelatedInfo:any){
    this.fieldTypeListParent.openModalRelatedInfo(fieldRelatedInfo, this);
  }

  ngOnDestroy(){
      this.fieldTypeListParent.ngOnDestroy();
  }
}
